import { render, staticRenderFns } from "./landingPage.vue?vue&type=template&id=44f9458a&scoped=true"
import script from "./landingPage.vue?vue&type=script&lang=ts"
export * from "./landingPage.vue?vue&type=script&lang=ts"
import style0 from "./landingPage.vue?vue&type=style&index=0&id=44f9458a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f9458a",
  null
  
)

export default component.exports